<template>
  <v-card @click="openCard(schedule)" class="pa-0 ma-0">
    <v-card-title class="secondary pa-0 ma-0 pa-1">
      <v-icon dark size="16" class="mr-4">mdi-calendar-text</v-icon>
      <h2 class="subtitle-2 white--text font-weight-bold">
        {{ schedule.date | date }} - {{ schedule.time | timeToHM }}
      </h2>
    </v-card-title>
    <v-container class="pa-0 ma-0 pa-1">
      <v-row class="pa-0 ma-0">
        <v-col cols="12" class="pa-0 ma-0 pa-1" align="start">
          <v-icon class="mr-2 ">mdi-account</v-icon>
          {{ (schedule.scheduledToUser) ? `Agendado para você` : `${schedule.patient}` }}
        </v-col>
        <v-col cols="12" class="pa-0 ma-0 pa-1" align="start">
          <v-icon class="mr-2">mdi-medical-bag</v-icon>
          {{schedule.professional}}
        </v-col>
        <v-col cols="12" class="pa-0 ma-0 pa-1" align="start">
          <v-icon class="mr-2">mdi-alpha-e-box</v-icon>
          {{schedule.speciality}}
        </v-col>
        <v-col cols="12" class="pa-0 ma-0 pa-1" align="start">
          <v-icon class="mr-2">mdi-account-tie-voice</v-icon>
          <span v-if="schedule.serviceChannelName == 'Consultório Online'">
            {{schedule.serviceChannelName}}:
            <a target="_blank" rel="noopener noreferrer" :href="schedule.serviceChannelUrl" v-if="schedule.status == 'scheduled'">
              Link para Consulta Online
            </a>
          </span>
          <span v-else-if="schedule.serviceChannelName && schedule.serviceChannelUrl">
            {{schedule.serviceChannelName}}: {{schedule.serviceChannelUrl}}
          </span>
          <span v-else>
            Presencial
          </span>
          
        </v-col>
        <v-col cols="12" class="pa-0 ma-0 pa-1" align="start">
          <v-icon class="mr-2">{{ statusFrmt[schedule.status].icon }}</v-icon>
          {{ statusFrmt[schedule.status].lbl }}
          <v-btn text v-if="schedule.status == 'scheduled'" @click.stop="cancelSchedule"
            :loading="cancelBtnLoading" color="secondary">
            Cancelar
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import bus from '@/plugins/eventBus';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    statusFrmt: {
      scheduled: { lbl: 'Agendado', icon: 'mdi-clock' },
      attended: { lbl: 'Atendido', icon: 'mdi-check-circle-outline' },
      canceled: { lbl: 'Cancelado', icon: 'mdi-cancel' },
      pending: { lbl: 'Pendente', icon: 'mdi-account-clock-outline' },
    },
    schedule: null,
    cancelBtnLoading: false,
  }),  
  created() {
    this.schedule = { ...this.value };
  },
  methods: {
    openCard(schedule) {
      this.$emit('open', schedule);
    },
    cancelSchedule() {
      this.cancelBtnLoading = true;
      this.$store
        .dispatch('patientSchedules/cancel', { patientId: this.schedule.patientId, scheduleId: this.schedule.id })
        .then(() => {
          bus.$emit('message', {
            message: 'Agendamento cancelado com sucesso!',
            type: 'success',
          });

          this.schedule.status = 'canceled';
          this.$emit('input', this.schedule);
        })
        .catch((err) => {
          bus.$emit('message', {
            message: err.response.data.message,
            type: 'error',
          });
        })
        .finally(() => {
          this.cancelBtnLoading = false;
        });
    },
  },
};
</script>
